import React, { useState } from "react";
import Newsletter from "@components/Newsletter/Newsletter";
import { i18n, useTranslation } from "next-i18next";
import SliderDefault from "../../../components/helper/sliderDefault";

export default function Partners(props) {
  const [data, setData] = useState([
    {
      image:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Homepage/Partner-Logos/Ozeankind-logo.jpg",
      customClass: "h-[168px] w-[189px] object-center object-scale-down pr-8",
      link: "https://ozeankind.de/",
    },
    {
      image:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Homepage/Partner-Logos/ganzwunderbar-Logo.png",
      customClass: "h-[168px] w-[189px] object-center object-scale-down pr-8",
      link: "https://www.ganzwunderbar.com/",
    },
    {
      image:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Homepage/Partner-Logos/travelsecure_logo.png",
      customClass: "h-[168px] w-[189px] object-center object-scale-down pr-8",
      link: "https://www.travelsecure.de/",
    },
    {
      image:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Homepage/Partner-Logos/Lapoint-Surfcamps.png",
      customClass: "h-[168px] w-[189px] object-center object-scale-down pr-8",
    },
    {
      image: "/main/partnerslogo/p1.jpg",
    },
    {
      image: "/main/partnerslogo/p2.jpg",
    },
    {
      image: "/main/partnerslogo/p3.jpg",
    },
    {
      image: "/main/partnerslogo/p4.jpg",
    },
    {
      image: "/main/partnerslogo/p5.jpg",
    },
    {
      image: "/main/partnerslogo/p6.jpg",
    },
    {
      image: "/main/partnerslogo/p7.jpg",
    },
    {
      image: "/main/partnerslogo/p8.jpg",
    },
    {
      image: "/main/partnerslogo/p9.jpg",
    },
    {
      image: "/main/partnerslogo/p10.jpg",
    },
    {
      image: "/main/partnerslogo/p11.jpg",
    },
    {
      image: "/main/partnerslogo/p12.jpg",
    },
    {
      image: "/main/partnerslogo/p13.jpg",
    },
    {
      image: "/main/partnerslogo/p14.jpg",
    },
    {
      image: "/main/partnerslogo/p15.jpg",
    },
    {
      image: "/main/partnerslogo/p16.jpg",
    },
    {
      image: "/main/partnerslogo/p17.jpg",
    },
    {
      image: "/main/partnerslogo/p18.jpg",
    },
    {
      image: "/main/partnerslogo/p19.jpg",
    },
    {
      image: "/main/partnerslogo/p20.jpg",
    },
    {
      image: "/main/partnerslogo/p21.jpg",
    },
    {
      image: "/main/partnerslogo/p22.jpg",
    },
    {
      image: "/main/partnerslogo/p23.jpg",
    },
    {
      image: "/main/partnerslogo/p24.jpg",
    },
    {
      image: "/main/partnerslogo/p25.jpg",
    },
    {
      image: "/main/partnerslogo/p26.jpg",
    },
    {
      image: "/main/partnerslogo/p27.jpg",
    },
    {
      image: "/main/partnerslogo/p28.jpg",
    },
    {
      image: "/main/partnerslogo/p29.jpg",
    },
    {
      image: "/main/partnerslogo/p30.jpg",
    },
    {
      image: "/main/partnerslogo/p31.jpg",
    },
    {
      image: "/main/partnerslogo/p32.jpg",
    },
    {
      image: "/main/partnerslogo/p33.jpg",
    },
    {
      image: "/main/partnerslogo/p34.jpg",
    },
    {
      image: "/main/partnerslogo/p35.jpg",
    },
    {
      image: "/main/partnerslogo/p36.jpg",
    },
    {
      image: "/main/partnerslogo/p37.jpg",
    },
    {
      image: "/main/partnerslogo/p38.jpg",
    },
    {
      image: "/main/partnerslogo/p39.jpg",
    },
    {
      image: "/main/partnerslogo/p40.jpg",
    },
    {
      image: "/main/partnerslogo/p41.jpg",
    },
    {
      image: "/main/partnerslogo/p42.jpg",
    },
    {
      image: "/main/partnerslogo/p43.jpg",
    },
    {
      image: "/main/partnerslogo/p44.jpg",
    },
    {
      image: "/main/partnerslogo/p45.jpg",
    },
    {
      image: "/main/partnerslogo/p46.jpg",
    },
    {
      image: "/main/partnerslogo/p47.jpg",
    },
    {
      image: "/main/partnerslogo/p48.jpg",
    },
    {
      image: "/main/partnerslogo/p49.jpg",
    },
  ]);
  const { t } = useTranslation("common");
  return (
    <div>
      <div className={props?.newletterClass}>
        <Newsletter
          image1={"/static/images/news.png"}
          image2={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Aktivurlaub_moverii.jpg"
          }
          image3={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Yoga-Retreats_moverii.jpg"
          }
          title={t("contact.newsletter_title")}
          description={t("contact.newsletter_description")}
          inputPlaceholder={t("contact.newsletter_placeholder")}
          buttonTitle={t("contact.newsletter_button")}
        />
      </div>
      <div className={"container px-4 md:px-0 mx-auto my-[100px] "}>
        <SliderDefault data={data} />
      </div>
    </div>
  );
}
